export default {
  testMediaList: [],
  testMediaCounted: null,
  testMediaFormated: [],
  testMediaContaminated: [],
};
